import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Form, Input, Select, Button } from 'antd';
import {
  createKnowledgebaseOverridesAction,
  listKnowledgebaseOverridesAction,
} from '../../../../../store/actions/knowledgebaseoverrides';
import { getAllSpecialtyListAction } from '../../../../../store/actions/specialty.action';
const { Option } = Select;
const { TextArea } = Input;

// Constants for select options based on the model definition
const ENCOUNTER_PHASES = ['pre-chart', 'in-visit', 'after-visit', 'dictate'];
const ENCOUNTER_TYPES = [
  'intake',
  'followup',
  'ambient',
  'note',
  'icd-10',
  'cpt',
];

const AddNewKnowledgeBaseOverrides = ({
  isOpen,
  setIsOpen,
  filterValue,
  orgUuid,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [contentText, setContentText] = useState('');

  const { specialties } = useSelector((state) => ({
    specialties: state?.specialtyState?.getAllSpecialtiesList,
  }));

  useEffect(() => {
    dispatch(getAllSpecialtyListAction());
  }, [dispatch]);

  const handleClose = () => {
    form.resetFields();
    setContentText('');
    setIsOpen(false);
  };

  const handleSubmit = (values) => {
    if (!orgUuid) {
      console.error('Organization UUID is required');
      return;
    }

    const payload = {
      specialty_id: values.specialty_id || null,
      content: contentText.trim(),
      encounter_phase: values.encounter_phase,
      encounter_type: values.encounter_type,
    };

    dispatch(
      createKnowledgebaseOverridesAction(orgUuid, payload, () => {
        handleClose();
        dispatch(listKnowledgebaseOverridesAction(orgUuid, filterValue));
      })
    );
  };

  return (
    <Modal
      title="Add New Knowledge Base Override"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={600}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="specialty_id" label="Specialty">
          <Select
            placeholder="Select specialty"
            showSearch
            allowClear
            options={specialties?.map((specialty) => ({
              label: specialty.name || specialty.specialty_name,
              value: specialty.specialty_id,
            }))}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          ></Select>
        </Form.Item>

        <Form.Item
          name="encounter_phase"
          label="Encounter Phase"
          rules={[
            { required: true, message: 'Please select a encounter phase' },
          ]}
        >
          <Select placeholder="Select encounter phase" allowClear showSearch>
            {ENCOUNTER_PHASES.map((phase) => (
              <Option key={phase} value={phase}>
                {phase}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="encounter_type"
          label="Encounter Type"
          rules={[
            { required: true, message: 'Please select a encounter type' },
          ]}
        >
          <Select placeholder="Select encounter type" allowClear showSearch>
            {ENCOUNTER_TYPES.map((type) => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="content"
          label="Content"
          rules={[{ required: true, message: 'Please enter content' }]}
        >
          <TextArea
            value={contentText}
            onChange={(e) => setContentText(e.target.value)}
            placeholder="Enter the knowledge base content here"
            autoSize={{ minRows: 5, maxRows: 15 }}
            className="w-full"
          />
        </Form.Item>

        <div className="flex justify-end">
          <Button onClick={handleClose} className="mr-2">
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" disabled={!orgUuid}>
            Submit
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddNewKnowledgeBaseOverrides;
